<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useIntervalFn } from '@vueuse/core'

import { getTimeDiff } from '@/components/UI/ResendCode/utils/helpers'

const {
  title = 'Didn\'t get the code?',
  resendLabel = 'Resend code',
  lastSendTime,
  delay,
  loading = false,
} = defineProps<{
  title?: string
  resendLabel?: string
  lastSendTime: number
  delay: number
  loading?: boolean
}>()

const emit = defineEmits<{
  click: []
}>()

const time = ref<number | undefined>(undefined)

const { pause, resume } = useIntervalFn(() => {
  updateTime()
  if (isResendAvailable.value) pause()
}, 1000)

const isResendAvailable = computed(() => time.value !== undefined && time.value <= 0)

const countdown = computed(() => {
  const seconds = Math.max(time.value ?? 0, 0)
  const mm = Math.floor(seconds / 60)
  const ss = String(seconds % 60).padStart(2, '0')
  return `${mm}:${ss}`
})

const updateTime = () => {
  time.value = getTimeDiff(lastSendTime, delay)
}

watch(
  () => lastSendTime,
  () => {
    updateTime()
    resume()
  },
  { immediate: true },
)
</script>

<template>
  <p class="text-center text-sm font-medium text-muted-foreground">
    <span>{{ title }}</span>
    &nbsp;
    <button
      v-if="isResendAvailable"
      type="button"
      class="font-semibold text-brand disabled:pointer-events-none disabled:opacity-50 hover:underline cursor-pointer underline-offset-2"
      :disabled="loading"
      @click="emit('click')"
    >
      {{ resendLabel }}
    </button>
    <span
      v-else
      class="tabular-nums"
    >Resend in {{ countdown }}</span>
  </p>
</template>
